import axios from "axios";
import { fetchMachineList } from "./machine";

const assetHierarchyUrl = "/api/asset-hierarchy";

const throwResponseData = (error) => {
  throw error.response?.data ?? error;
};

export const fetchAssetHierarchyTree = async (companyKey, includeInactive = false) => {
  try {
    const response = await axios.get(`${assetHierarchyUrl}/tree`, {
      params: { companyKey, includeInactive },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const fetchAssetHierarchyChildren = async (companyKey, parentAssetNodeId = null, includeInactive = false) => {
  try {
    const response = await axios.get(`${assetHierarchyUrl}/children`, {
      params: { companyKey, parentAssetNodeId, includeInactive },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

// Flat list of Department nodes, not a tree — the source for the department picker in
// user administration.
export const fetchDepartments = async (companyKey, includeInactive = false) => {
  try {
    const response = await axios.get(`${assetHierarchyUrl}/departments`, {
      params: { companyKey, includeInactive },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const fetchAssetNode = async (companyKey, id) => {
  try {
    const response = await axios.get(`${assetHierarchyUrl}/${id}`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const createAssetNode = async (assetNode) => {
  try {
    const response = await axios.post(assetHierarchyUrl, assetNode);
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const updateAssetNode = async (id, assetNode) => {
  try {
    const response = await axios.patch(`${assetHierarchyUrl}/${id}`, assetNode);
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const reparentAssetNode = async (id, companyKey, newParentAssetNodeId) => {
  try {
    const response = await axios.patch(`${assetHierarchyUrl}/${id}/parent`, {
      companyKey,
      newParentAssetNodeId,
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const deactivateAssetNode = async (companyKey, id) => {
  try {
    const response = await axios.delete(`${assetHierarchyUrl}/${id}`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const assignMachineToAssetNode = async (companyKey, assetNodeId, machineId) => {
  try {
    const response = await axios.patch(`${assetHierarchyUrl}/${assetNodeId}/machines/${machineId}`, null, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const unassignMachineFromAssetNode = async (companyKey, machineId) => {
  try {
    const response = await axios.delete(`${assetHierarchyUrl}/machines/${machineId}/asset-node`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

// The document must already belong to the node and be a JPEG, PNG, GIF or WebP image.
export const setAssetNodeOverviewImage = async (companyKey, assetNodeId, documentId) => {
  try {
    const response = await axios.put(`${assetHierarchyUrl}/${assetNodeId}/overview-image`, {
      companyKey,
      documentId,
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

// Clears the pointer only. The document stays in the node's list.
export const clearAssetNodeOverviewImage = async (companyKey, assetNodeId) => {
  try {
    const response = await axios.delete(`${assetHierarchyUrl}/${assetNodeId}/overview-image`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const fetchAssetHierarchyMachineCandidates = fetchMachineList;
